import { sanitizeFilename } from './sanitizeFilename';
const DOWNLOAD_DELAY_MS = 1000;
const BLOB_URL_REVOKE_DELAY_MS = 10000;
export async function downloadBlob(blob, filename) {
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = sanitizeFilename(filename);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setTimeout(() => URL.revokeObjectURL(blobUrl), BLOB_URL_REVOKE_DELAY_MS);
    await new Promise((resolve) => setTimeout(resolve, DOWNLOAD_DELAY_MS));
}
